const XLSX_MIME =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

const OPERATOR_ROLE_ID = 5;

export const canAccessLocalBilling = (userData: any) =>
  userData?.userPositionRu === "Администратор" ||
  (Array.isArray(userData?.selectRoleV2) &&
    userData.selectRoleV2.some(
      (role: { roleId: number }) => role.roleId === OPERATOR_ROLE_ID,
    ));

export const formatBillingAmount = (value?: number) => {
  if (value == null) return "-";
  return new Intl.NumberFormat("ru-RU", {
    minimumFractionDigits: 8,
    maximumFractionDigits: 8,
  }).format(value);
};

export const downloadXlsxBlob = (blob: Blob, fileName: string) => {
  const fileBlob =
    blob.type === XLSX_MIME ? blob : new Blob([blob], { type: XLSX_MIME });
  const url = window.URL.createObjectURL(fileBlob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName.endsWith(".xlsx") ? fileName : `${fileName}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.parentNode?.removeChild(link);
  window.URL.revokeObjectURL(url);
};
